export type CallListTableSectionVisibilityInput = {
  isVoiceStandAlone: boolean
  voiceStandaloneBootstrapComplete: boolean
  isLoading: boolean
  totalCalls: number | null
  hasActiveFilters: boolean
  showVoiceStandaloneCallList: boolean
}

/**
 * Whether the call list filters + table shell should render instead of the voice standalone empty state.
 */
export function shouldShowCallListTableSection(
  input: CallListTableSectionVisibilityInput
): boolean {
  if (!input.isVoiceStandAlone) {
    return true
  }
  if (!input.voiceStandaloneBootstrapComplete) {
    return true
  }
  if (input.isLoading) {
    return true
  }
  if (input.totalCalls !== null && input.totalCalls > 0) {
    return true
  }
  if (input.totalCalls === 0 && input.hasActiveFilters) {
    return true
  }
  if (input.showVoiceStandaloneCallList) {
    return true
  }
  return false
}
